import React from "react";
import { useTranslation } from "react-i18next";

export const RegisterMailPage = () => {
  const { t } = useTranslation();

  return (
    <main>
      <section className="container__standart">
        <h2
          style={{
            padding: "18.75rem 0rem 12.5rem 0rem",
            textAlign: "center",
          }}
        >
          {t("registerMailPage.message")}
          <br />
          {t("registerMailPage.message1")}
          <br />
          {t("registerMailPage.message2")}
        </h2>
      </section>
    </main>
  );
};
